import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { MainContainer } from "./styles";
import CustomNotification from "../../../general/CustomNotification";
import useNotifications from "../../../../hooks/useNotification";

const UploadTemplate = () => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const { notifications, addNotification, deleteNotification } = useNotifications();

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        setFile(acceptedFiles[0]);
        setError(null);
        addNotification("success", `${acceptedFiles[0].name} cargado correctamente`);
      }
    },
    onDropRejected: () => {
      const errorMsg = "Solo se permiten archivos .csv o .xlsx";
      setError(errorMsg);
      addNotification("error", errorMsg);
    },
    accept: ".csv, .xlsx",
  });

  return (
    <MainContainer>
      <div className="indications">
        <h2 className="title">Subir archivo</h2>
        <p>Una vez tengas la plantilla llena, súbela aquí</p>
      </div>

      <div {...getRootProps()} className="drag-area">
        <input {...getInputProps()} id="file-input" style={{ display: "none" }} />
        {!file ? (
          <p className="drag-text">Arrastra y suelta el archivo aquí o haz clic para seleccionar</p>
        ) : null}
      </div>

      <CustomNotification
        open={notifications.length > 0}
        alerts={notifications}
        deleteNotification={deleteNotification}
      />
    </MainContainer>
  );
};

export default UploadTemplate;